<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <RegionCourtForm
      :form="form"
      @submit="submit"
      @previous-page="previousPage"
      :text-button="nameButton"
      :court="currentCourt"
    />
    <ModalCourt
      type="vara"
      v-model="modal"
      @submit="newRegionCourt"
      @close="closeModal"
      :court="currentCourt.nome"
    />
    <ModalCancelCourt
      @close="closeModalCancel"
      v-model="modalCancelCourt"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>
<script>
const BREADCRUMB_EDIT = [
  {
    text: "Editar Vara",
    to: "list region court"
  }
];
const BREADCRUMB_ADD = [
  {
    text: "Adicionar Nova Vara",
    to: "list region court"
  }
];
import RegionCourtForm from "../components/RegionCourtForm";
import ModalCourt from "../components/ModalCourt";
import { CommonPayload } from "@/mixins/PayloadDataTableMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { mapActions, mapState } from "vuex";
import ModalCancelCourt from "../../insurance_company/components/ModalCancelInsurance";
import { formatCode } from "@/utils/formats.js";
import _ from "lodash";
import FormMixin from "@/mixins/FormMixin";
export default {
  beforeRouteLeave(to, from, next) {
    this.modalCancelCourt = true;
    this.nextRoute = to;
    if (this.cancel || this.formIsPristineCommon(this.form, this.cloneForm))
      next();
  },
  data: () => ({
    form: {
      ativo: true
    },
    nameButton: null,
    breadcrumb: null,
    modal: false,
    modalCancelCourt: false,
    nextRoute: null,
    cancel: false,
    formatCode,
    cloneForm: {}
  }),
  components: {
    RegionCourtForm,
    ModalCourt,
    ModalCancelCourt
  },
  mixins: [CommonPayload, LoadingRequest, FormMixin],
  created() {
    this.isEditRegionCourt();
  },
  computed: {
    ...mapState("court", ["currentRegionCourt", "currentCourt"]),
    isEdit() {
      return Boolean(this.$route.params.vara);
    }
  },
  methods: {
    ...mapActions("court", [
      "requestEditRegionCourt",
      "requestCurrentRegionCourt",
      "requestNewRegionCourt",
      "requestCurrentCourt"
    ]),
    ...mapActions(["showAlertNotification"]),
    submit(form) {
      //TODO: Fazer integração
      if (this.isEdit) {
        this.withLoading(
          this.requestEditRegionCourt(this.payloadRegionCourt(form)).then(
            () => {
              this.showAlertNotification({
                message: "Vara editada com sucesso.",
                type: "success"
              });
              this.closeModal();
            }
          )
        );
      } else {
        this.withLoading(
          this.requestNewRegionCourt(this.payloadRegionCourt(form)).then(
            () => (this.modal = true)
          )
        );
      }
    },
    isEditRegionCourt() {
      this.nameButton = this.isEdit ? "SALVAR" : "ADICIONAR";
      this.breadcrumb = this.isEdit ? BREADCRUMB_EDIT : BREADCRUMB_ADD;
      if (this.isEdit) {
        this.fetchCurrentRegionCourt();
      } else {
        this.fetchCurrentCourt();
      }
    },
    fetchCurrentCourt() {
      this.withLoading(this.requestCurrentCourt(this.$route.params.tribunal));
    },
    async fetchCurrentRegionCourt() {
      const response = await this.withLoading(
        Promise.all([
          this.requestCurrentCourt(this.$route.params.tribunal),
          this.requestCurrentRegionCourt(this.payloadRegionCourt())
        ])
      );
      this.form = response[1];
      this.form.codigo = this.formatCode(this.form.codigo, 4);
      this.cloneForm = _.cloneDeep(this.form);
    },
    payloadRegionCourt(payload) {
      return {
        tribunal: this.$route.params.tribunal,
        vara: this.$route.params.vara,
        payload: payload
      };
    },
    previousPage() {
      this.$router.push({
        name: "list region court",
        params: { tribunal: this.$route.params.tribunal }
      });
    },
    newRegionCourt() {
      this.modal = false;
      this.form = {};
      this.cloneForm = {};
    },
    closeModal() {
      this.modal = false;
      this.cancel = true;
      this.previousPage();
    },
    closeModalCancel(value) {
      this.cancel = value;
      this.modalCancelCourt = false;
      if (value) {
        this.$router.push({
          name: this.nextRoute.name,
          params: this.nextRoute.params
        });
      }
    }
  }
};
</script>
